/* ==========================================================================
   Cart drawer — TOTAL-regel en review-blok.

   Waarom JavaScript en geen Liquid: de drawer zelf zit in
   snippets/cart-drawer.liquid (54 KB maatwerk) en daar heeft het dashboard-
   token geen leesrechten op. Blind in een bestand van die omvang schrijven is
   vragen om schade, dus voegt dit bestand de twee ontbrekende onderdelen toe
   aan de al gerenderde drawer. Zodra read_themes goed staat hoort dit in de
   snippet zelf — dan kan dit bestand weg.

   Dawn hertekent de drawer bij elke cart-wijziging via de Section Rendering
   API, dus we luisteren op DOM-wijzigingen en tekenen opnieuw.
   ========================================================================== */

(function () {
  'use strict';

  var cfg = window.KOPELIT_CART_DRAWER || {};
  var observer = null;

  /* "£111.90" -> {amount: 111.9, prefix: "£", suffix: ""}. De winkel staat in
     GBP maar de opmaak komt uit de pagina zelf, zodat een valutawissel of een
     andere geldnotatie vanzelf goed blijft gaan. */
  function parseMoney(text) {
    if (!text) return null;
    var cleaned = text.replace(/\s+/g, ' ').trim();
    var match = cleaned.match(/([^\d\-]*)(-?[\d.,]+)(.*)$/);
    if (!match) return null;

    var digits = match[2];
    // Laatste scheidingsteken met 2 cijfers erachter is de decimaalscheiding.
    var decimal = digits.match(/[.,](\d{2})$/);
    var amount;
    if (decimal) {
      amount = parseFloat(
        digits.slice(0, digits.length - 3).replace(/[.,]/g, '') + '.' + decimal[1]
      );
    } else {
      amount = parseFloat(digits.replace(/[.,]/g, ''));
    }
    if (isNaN(amount)) return null;

    return { amount: amount, prefix: match[1], suffix: match[3] || '' };
  }

  /* De geldnotatie van deze winkel plakt de ISO-code achter elk bedrag
     ("£71.91 GBP"). Drie van die bedragen naast elkaar passen niet op de
     breedte van de drawer, dus laat de TOTAL-regel de code weg — de
     checkout-knop eronder noemt de valuta al. */
  function formatMoney(amount, like, dropSuffix) {
    var body = amount.toFixed(2);
    // Neem de decimaalkomma over van het voorbeeld (£1.00 vs € 1,00).
    if (like && /,\d{2}\s*\D*$/.test(like.raw || '')) body = body.replace('.', ',');
    return (like.prefix || '') + body + (dropSuffix ? '' : like.suffix || '');
  }

  function buildTotals(drawer) {
    var totals = drawer.querySelector('.totals');
    var valueEl = totals && totals.querySelector('.totals__total-value');
    var labelEl = totals && totals.querySelector('.totals__total');
    if (!totals || !valueEl || !labelEl) return;

    var now = parseMoney(valueEl.getAttribute('data-kop-raw') || valueEl.textContent);
    if (!now) return;
    // Bewaar de oorspronkelijke tekst: bij een tweede ronde staat onze eigen
    // opmaak er al in en zou het bedrag anders uit de badge gelezen worden.
    valueEl.setAttribute('data-kop-raw', valueEl.textContent.replace(/\s+/g, ' ').trim());
    now.raw = valueEl.getAttribute('data-kop-raw');

    // "Vanaf"-prijs = som van de doorgestreepte regelprijzen. Staat er geen
    // enkele, dan is er niets af en tonen we alleen het bedrag.
    var was = 0;
    drawer.querySelectorAll('.cart-item__old-price').forEach(function (el) {
      var m = parseMoney(el.textContent);
      if (m) was += m.amount;
    });

    var saved = was > now.amount ? was - now.amount : 0;

    labelEl.textContent = cfg.totalLabel || 'TOTAL:';

    valueEl.innerHTML = '';
    // Opnieuw tekenen mag niets opstapelen: de drawer wordt bij elke
    // cart-wijziging hertekend en de reserveringstimer tikt elke seconde.
    drawer.querySelectorAll('.kop-total__spacer').forEach(function (el) {
      el.remove();
    });
    var spacer = document.createElement('span');
    spacer.className = 'kop-total__spacer';
    valueEl.parentNode.insertBefore(spacer, valueEl);

    if (saved > 0) {
      var wasEl = document.createElement('span');
      wasEl.className = 'kop-total__was';
      wasEl.textContent = formatMoney(was, now, true);
      valueEl.appendChild(wasEl);
      valueEl.appendChild(document.createTextNode(' '));
    }

    var nowEl = document.createElement('span');
    nowEl.className = 'kop-total__now';
    nowEl.textContent = formatMoney(now.amount, now, true);
    valueEl.appendChild(nowEl);

    if (saved > 0) {
      var badge = document.createElement('span');
      badge.className = 'kop-total__badge';
      badge.textContent = '-' + formatMoney(saved, now, true);
      valueEl.appendChild(document.createTextNode(' '));
      valueEl.appendChild(badge);
    }
  }

  /* Het bedrag staat sinds de TOTAL-regel twee keer onder elkaar. Uit de knop
     halen, zodat daar alleen de handeling blijft staan. De knop wordt bij elke
     cart-wijziging opnieuw gerenderd, dus dit draait telkens mee; na de eerste
     keer zit er geen scheidingsteken meer in en gebeurt er niets. */
  function buildCheckout(drawer) {
    var btn = drawer.querySelector('.cart__checkout-button');
    if (!btn) return;

    var text = btn.textContent;
    var cut = text.indexOf('\u2022');
    if (cut === -1) return;

    btn.textContent = text.slice(0, cut).trim();
  }

  function buildReviews(drawer) {
    if (!cfg.showReviews) return;
    if (drawer.querySelector('.kop-reviews')) return;

    // De grijze lijn is de border-top van .drawer__footer, dus het blok komt
    // daar vlak boven te staan — nog binnen het scrollgebied van de mand.
    var anchor = drawer.querySelector('.drawer__footer') || drawer.querySelector('.cart__ctas');
    if (!anchor) return;

    var box = document.createElement('div');
    box.className = 'kop-reviews';

    var left = document.createElement('div');
    left.className = 'kop-reviews__left';

    var stars = document.createElement('span');
    stars.className = 'kop-reviews__stars';
    stars.textContent = cfg.reviewStars || '★★★★★';
    stars.setAttribute('aria-hidden', 'true');

    var score = document.createElement('span');
    score.className = 'kop-reviews__score';
    score.textContent = cfg.reviewScore || '';

    left.appendChild(stars);
    left.appendChild(score);

    var count = document.createElement('span');
    count.className = 'kop-reviews__count';
    count.textContent = cfg.reviewCount || '';

    box.appendChild(left);
    box.appendChild(count);
    anchor.parentNode.insertBefore(box, anchor);
  }

  function render() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;

    // Onze eigen wijzigingen mogen de observer niet opnieuw laten afgaan.
    if (observer) observer.disconnect();
    try {
      buildTotals(drawer);
      buildCheckout(drawer);
      buildReviews(drawer);
    } finally {
      if (observer) watch();
    }
  }

  function watch() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer || !observer) return;
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function start() {
    if (!document.querySelector('#CartDrawer')) return;

    var pending = null;
    observer = new MutationObserver(function (records) {
      // De afteltimer verandert elke seconde van tekst. Daar hoeft de
      // TOTAL-regel niet op te reageren.
      var relevant = records.some(function (rec) {
        // Bij een tekstwijziging is het doelwit een tekstknoop; die kent geen
        // closest(), dus eerst naar het omliggende element.
        var node = rec.target;
        var el = node.nodeType === 1 ? node : node.parentElement;
        return !(el && el.closest('.cart-reservation-timer'));
      });
      if (!relevant) return;
      clearTimeout(pending);
      pending = setTimeout(render, 60);
    });

    render();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
